import React, { useState } from 'react';
import { createPortal } from 'react-dom';

const UnitConverter = () => {
    const [feet, setFeet] = useState('');
    const [meters, setMeters] = useState('');
    const [open, setOpen] = useState(false);

    const handleFeetChange = (e) => {
        const val = e.target.value;
        setFeet(val);
        if (val === '') {
            setMeters('');
        } else {
            setMeters((parseFloat(val) / 3.28084).toFixed(3));
        }
    };

    const handleMetersChange = (e) => {
        const val = e.target.value;
        setMeters(val);
        if (val === '') {
            setFeet('');
        } else {
            setFeet((parseFloat(val) * 3.28084).toFixed(3));
        }
    };

    // Portal to <body> so a blurred/transformed parent can't break position: fixed
    return createPortal(
        <div className="fixed right-0 top-1/3 z-40 flex items-start">
            <button
                onClick={() => setOpen(!open)}
                title="Unit Converter"
                className="bg-purple-600 hover:bg-purple-500 text-white font-bold text-sm px-2 py-4 rounded-l-xl shadow-lg"
                style={{ writingMode: 'vertical-rl' }}
            >
                {open ? 'Close ✕' : 'ft ⇄ m'}
            </button>
            {open && (
                <div className="glass rounded-l-2xl p-4 shadow-2xl border border-purple-500/20 bg-slate-900/95 w-48">
                    <h3 className="text-sm font-bold text-purple-300 mb-3 text-center">Unit Converter</h3>
                    <label className="text-purple-200 text-xs ml-1">Feet (ft)</label>
                    <input
                        type="number"
                        placeholder="0"
                        value={feet}
                        onChange={handleFeetChange}
                        className="input-glow bg-white/10 border border-white/20 rounded-xl px-3 py-2 text-lg placeholder-purple-300 text-white w-full text-center mb-2"
                    />
                    <div className="text-purple-400 font-bold text-center">⇅</div>
                    <label className="text-purple-200 text-xs ml-1">Meters (m)</label>
                    <input
                        type="number"
                        placeholder="0"
                        value={meters}
                        onChange={handleMetersChange}
                        className="input-glow bg-white/10 border border-white/20 rounded-xl px-3 py-2 text-lg placeholder-purple-300 text-white w-full text-center"
                    />
                </div>
            )}
        </div>,
        document.body
    );
};

export default UnitConverter;
